import { EnrollmentSummaryDto } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MprcRequestErrorReport, MprcSpinnerIndicator } from '../../../../../components';
import { MprcSimpleDialog } from '../../../../../components/MprcSimpleDialog';
import { EnrollmentSummary } from './EnrollmentSummary';

////////////////////////////////////////////////////////////////////////////
interface IProps {
    enrollmentId: string;
    onClose: () => void;
}

////////////////////////////////////////////////////////////////////////////

export const ProgressDetailsDialog: React.FC<IProps> = (props) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    const { enrollmentId, onClose } = props;

    const [loading, setLoading] = useState<boolean>(true);
    const [viewData, setViewData] = useState<EnrollmentSummaryDto>();
    const [viewError, setViewError] = useState<any>();

    /////////////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        setLoading(true);
        api.v1.enrollment.getProgressDetail({ enrollmentId })
            .then(response => setViewData(response.data.summary))
            .catch(e => setViewError(e))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <MprcSimpleDialog
                width="sm"
                title={t("Student.EnrollmentView.ProgressDetailsDialog.Title")}
                subtitle={viewData?.trainingName ?? ""}
                message={
                    <>
                        <MprcRequestErrorReport error={viewError} />
                        {loading
                            ? <MprcSpinnerIndicator />
                            : viewData && <EnrollmentSummary data={viewData} mode="student" />
                        }
                    </>
                }
                onClose={onClose}
            />
        </>
    );
};
